import React from "react";
import { GOAL_METHODS, TimelineEvent } from "../Types";
import { TimelineScore } from "../GameTimeline.styles";
import { TimelineItem } from "../TimelineItem";
import { TimelineItemTitle } from "./GameTimelineFactory.styles";
import { usePlayerInfo } from "../../Hooks/usePlayerInfo";

export function MatchScoreChangeEvent({
    timelineEvent,
    opposite,
    title,
}: {
    opposite: boolean;
    timelineEvent: TimelineEvent;
    title: string;
}) {
    const { getPlayerInfo } = usePlayerInfo();
    const description =
        timelineEvent.scoringMethod === GOAL_METHODS.OWN_GOAL
            ? "Eigentor"
            : "Tor";

    const scorer = getPlayerInfo(timelineEvent, "scorer");
    return (
        <TimelineItem
            opposite={opposite}
            title={title}
            subline={scorer.name}
            playerData={scorer}
            icon={
                <TimelineScore>
                    {timelineEvent.homeScore}:{timelineEvent.awayScore}
                </TimelineScore>
            }
            headline={description}
        />
    );
}
